import React from 'react'
import styles from './MicrositeFeatureFlagGrid.module.css'
import { Check, X } from 'lucide-react'

const FEATURE_LABELS = {
    chat: 'Live chat widget',
    aiAssistant: 'AI assistant',
    analytics: 'Advanced analytics',
    billing: 'Billing integration',
    whiteLabel: 'White-label branding',
    customDomain: 'Custom domain'
}

/**
 * MicrositeFeatureFlagGrid
 * Read-only grid of feature flags from the plan config — salon
 * owners can see what's included but can't self-toggle (admin-set
 * via micrositeUpdateStorePlan). Used on MicrositePlan.
 *
 * Usage:
 *   <MicrositeFeatureFlagGrid features={plan.features} />
 *   // features: { chat: true, aiAssistant: true, whiteLabel: false, ... }
 */
const MicrositeFeatureFlagGrid = ({ features = {} }) => {
    const entries = Object.entries(features)

    if (!entries.length) {
        return <div className={styles.empty}>No feature flags configured for this plan</div>
    }

    return (
        <div className={styles.grid}>
            {entries.map(([key, enabled]) => (
                <div key={key} className={styles.row}>
                    <span className={enabled ? styles.iconOn : styles.iconOff}>
                        {enabled ? <Check size={13} /> : <X size={13} />}
                    </span>
                    <span className={enabled ? styles.labelOn : styles.labelOff}>
                        {FEATURE_LABELS[key] || key}
                    </span>
                </div>
            ))}
        </div>
    )
}

export default MicrositeFeatureFlagGrid